export const PAGE_SIZE = 20;
export const ACTIVITY_IMAGE_BASE_URL =
  'https://content.linktivity.io/supplier-link-dev/';

export const MAX_IMAGES = 5;
export const LANGUAGE = 'lang';

export const BOOKING_STEP = {
  BASE: 0,
  REQUIRE: 1,
  CONFIRMATION: 2
};

export const FIREBASE_ACCOUNT_LOGO_FOLDER =
  'gds-neo-static/agent/account/logo/';

export const ROUTE_PREFIX = {
  BOOKING: '/book/search-activities',
  BULK_ORDER: '/bulk-order/search-activities'
};
